module.exports = __webpack_public_path__ + "img/bg36.40555e85.png";